module.exports = "/_next/static/images/execution-9845d0d41af044ab2b56eff39f902172.webp";